"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchBlob = fetchBlob;
exports.fetchJson = fetchJson;
require("whatwg-fetch");
const jsonFetchConfig = {
  method: 'GET',
  headers: {
    'Accept': 'application/json'
  }
};
function fetchJson(path) {
  return fetch(path, jsonFetchConfig).then(resp => resp.json());
}
function fetchBlob(url) {
  return fetch(url).then(resp => {
    if (resp.ok) {
      return resp.blob();
    }
  });
}